import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { getSqrDefaultContent } from '../../pre-ready-tepmlate';

@Component({
  selector: 'app-psqr-to-sqr',
  standalone: false,
  templateUrl: './psqr-to-sqr.component.html'
})
export class PsqrToSqrComponent implements OnInit, AfterViewInit {
  @Input() id: any
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  rfpdata: any;
  previousInit: EditorComponent['init'] = init;
  sqrEditorInit: EditorComponent['init'] = init;
  uploadedFileName: string = '';
  file: File;

  sqrDefaultContent: string = getSqrDefaultContent();
  userID: any;




  constructor(private fb: FormBuilder, private messageService: MessageService,
    private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      justification: ['', Validators.required],
      sqr_content: [''],
      introduction: [this.sqrDefaultContent],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.challengeForm = this.fb.group({
      essential_parameter: [''],
      desirable_parameter: [''],
      functional_req: [''],
      performance_req: [''],
      technical_req: [''],
      operational_req: [''],
      logistical_req: [''],
      cost_req: [''],
      timeline_req: [''],
      additonal_req: [''],
      proposal_step: [null],
    });


    this.getRfpDetails();

  }
  ngAfterViewInit() {
    this.previousInit = {
      ...this.init,
      readonly: true
    };
    this.sqrEditorInit = {
      ...this.init,
      readonly: true,
      height: 600
    };
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  rebuildEditor() {
    this.init = {
      ...this.init,
      readonly: false
    };
  }


  ms_03Id: number;
  getRfpDetails(): void {
    let apiUrl = `/tdf/psqr/sqr/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`;
    if (['makeII', 'makeI', 'makeIII'].includes(this.schemeType)) {
      apiUrl = `/make1/psqr/sqr/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`;
    } else if (['idex'].includes(this.schemeType)) {
      apiUrl = `/idex/psqr/sqr/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`;
    }
    this.api.getAPI(apiUrl).subscribe((res: any) => {
      ;
      if (['idex'].includes(this.schemeType)) {
        this.ms_03Id = res.milestone_3;
        this.commentForm.patchValue({
          justification: res.sqr_data[0]?.justification,
          sqr_content: res.sqr_data[0]?.sqr_content || this.sqrDefaultContent,
          introduction: res.sqr_data[0]?.introduction || this.sqrDefaultContent
        });
        this.rfpdata = res.sqr_data[0];
      } else if (['makeII', 'makeI', 'makeIII'].includes(this.schemeType)) {
        this.rfpdata = res.sqr_data;
        console.log("test",this.rfpdata);
        this.challengeForm.patchValue(res.psqr_data);
        this.commentForm.patchValue({
          justification: res.sqr_data[0]?.justification || res.psqr_data?.justification || res.sqr_data?.justification,
          sqr_content: res.sqr_data[0]?.sqr_content || this.sqrDefaultContent,
          introduction: res.sqr_data[0]?.introduction || res.psqr_data?.introduction || this.sqrDefaultContent
        });
        this.challengeForm.disable();
      } else {
        this.rfpdata = res[0];
        this.commentForm.patchValue({
          justification: res[0]?.justification,
          sqr_content: res[0]?.sqr_content || this.sqrDefaultContent,
          introduction: res[0]?.introduction || this.sqrDefaultContent
        });
      }
    });
  }

  expandedSections = {
    detailedInfo: true,
    additionalInfo: false,
    uploads: false,
    mainExpansion: false,
  }


  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.stepDetails.id);
    formData.append('justification', this.commentForm.get('justification')?.value || '');
    formData.append('introduction', this.commentForm.get('sqr_content')?.value || '');

    let baseUrl = `/tdf/psqr/sqr/`;
    if (['makeII', 'makeI', 'makeIII'].includes(this.schemeType)) {
      baseUrl = `/make1/psqr/sqr/`;
    } else if (['idex'].includes(this.schemeType)) {
      baseUrl = `/idex/psqr/sqr/`;
    }

    if (this.rfpdata?.id) {
      this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data updated successfully'
        });
      });
    } else {
      this.api.postAPI(baseUrl, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data uploaded successfully'
        });
      });
    }
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "justification", value: this.commentForm.get('justification')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }


}
